import Section_1 from "../../Components/Sign in/Section-1";

export function Sign_in() {
    return <>
        <Section_1 />
    </>
}